/** @jsx jsx */
import { jsx } from '@emotion/react'
import { videoInstitutional } from '../assets/styles/VideoInstitutional.styles'

const VideoInstitutional = () => {
  return (

    <section css={videoInstitutional}>
      <div  className='text-container' data-aos="fade-up" data-aos-delay="300">
        
          <h2>Você sabia?</h2> 
          <p>No Brasil, mais de 90% dos pais e responsáveis afirmam que usam o Instagram com frequência. Ou seja, uma rede social bem estruturada pode transformar seguidores em parceiros, atrair alunos e consolidar a reputação da escola.</p>
       
      </div>
    </section>

  )
}

export default VideoInstitutional
